import React, { Suspense } from 'react';
import LoadingIndicator from '@v2/LoadingIndicator';

const withLazyAndSuspense = (importComponent) => {
  const LazyComponent = React.lazy(importComponent);

  return (props) => (
    <Suspense fallback={<LoadingIndicator />}>
      <LazyComponent {...props} />
    </Suspense>
  );
};
export default withLazyAndSuspense;